// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as VehicleHelper$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/VehicleHelper.mjs";
import * as MetaConstants$PorterinFeature from "../../constants/MetaConstants.mjs";
import * as MediaEntityMapper$PorterinFeature from "../../../media/domain/entity-mappers/MediaEntityMapper.mjs";

function getMeta(model, default_meta_title, default_meta_desc) {
  if (model === undefined) {
    return {
            title: default_meta_title,
            description: default_meta_desc,
            schemas: /* [] */0,
            image: {
              path: MetaConstants$PorterinFeature.default_image_src,
              alt_text: MetaConstants$PorterinFeature.default_image_alt
            },
            is_no_index: false
          };
  }
  var a = model.image;
  return {
          title: Belt_Option.getWithDefault(model.title, default_meta_title),
          description: Belt_Option.getWithDefault(model.description, default_meta_desc),
          schemas: Belt_List.concatMany([
                Belt_Option.mapWithDefault(model.faq_schema, /* [] */0, (function (x) {
                        return {
                                hd: x,
                                tl: /* [] */0
                              };
                      })),
                Belt_Option.mapWithDefault(model.review_schema, /* [] */0, (function (x) {
                        return {
                                hd: x,
                                tl: /* [] */0
                              };
                      })),
                Belt_Option.mapWithDefault(model.local_business_schema, /* [] */0, (function (x) {
                        return {
                                hd: x,
                                tl: /* [] */0
                              };
                      }))
              ]),
          image: a !== undefined ? ({
                path: a.image.data.attributes.url,
                alt_text: a.alt_text
              }) : ({
                path: MetaConstants$PorterinFeature.default_image_src,
                alt_text: MetaConstants$PorterinFeature.default_image_alt
              }),
          is_no_index: Belt_Option.getWithDefault(model.is_no_index, false)
        };
}

function getKnowMoreCta(model) {
  return {
          label: model.label,
          href: Belt_Option.getWithDefault(model.href, "")
        };
}

function getVehicleServicesInfo(model) {
  return $$Array.map((function (data) {
                return {
                        text: data.attributes.service_name,
                        service_type: VehicleHelper$PorterinUtils.fromString(data.attributes.service_type),
                        image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.attributes.service_icon)
                      };
              }), model);
}

function getVehicleCities(all_cities) {
  return $$Array.map((function (data) {
                return {
                        city_name: data.attributes.image.data.attributes.city_name.toLowerCase(),
                        city_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.attributes.image.data.attributes.image),
                        city_label: data.attributes.image.data.attributes.city_label,
                        city_services: getVehicleServicesInfo(data.attributes.services.data)
                      };
              }), all_cities);
}

function getTestimonial(model) {
  return {
          customer_name: model.customer_name,
          testimonial_text: model.testimonial_text,
          city: model.city,
          profile_pic: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.profile_pic),
          rating: model.rating,
          porter_service: model.porter_service
        };
}

function getCustomerTestimonials(model) {
  return {
          title: model.title,
          testimonials: Belt_Array.map(model.testimonials, getTestimonial)
        };
}

function getFaqs(model) {
  return $$Array.map((function (faq) {
                return {
                        question: faq.question,
                        answer: faq.answer
                      };
              }), model);
}

function getFaqsSection(model) {
  var sub_text = model.sub_text;
  return {
          title: model.title,
          sub_text: sub_text !== undefined ? sub_text : "",
          faqs: getFaqs(model.faqs),
          toggle_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.toggle_icon)
        };
}

function getTextSubtext(model) {
  return $$Array.map((function (text_subtext) {
                return {
                        text: text_subtext.text,
                        sub_text: text_subtext.sub_text
                      };
              }), model);
}

function getTestimonials(model, title) {
  return {
          title: title !== undefined ? title : "",
          testimonials: $$Array.map((function (testimonial) {
                  return {
                          customer_name: testimonial.customer_name,
                          testimonial_text: testimonial.testimonial_text,
                          city: testimonial.city,
                          profile_pic: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(testimonial.profile_pic),
                          rating: testimonial.rating,
                          porter_service: testimonial.porter_service
                        };
                }), model)
        };
}

function getCategoryService(model) {
  return $$Array.map((function (category_service) {
                return {
                        text: category_service.text,
                        image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(category_service.image),
                        sub_text: category_service.sub_text,
                        link: Belt_Option.getWithDefault(category_service.cta.href, ""),
                        service_type: category_service.service_type
                      };
              }), model);
}

function getServices(model) {
  return $$Array.map((function (service) {
                return {
                        text: service.text,
                        image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(service.image),
                        sub_text: service.sub_text,
                        link: Belt_Option.getWithDefault(service.cta.href, ""),
                        service_type: service.service_type
                      };
              }), model);
}

function getHomeCities(model) {
  return $$Array.map((function (city) {
                return {
                        city_name: city.attributes.city_name,
                        city_label: city.attributes.city_label,
                        city_link: city.attributes.city_link,
                        geo_region_id: city.attributes.city_id,
                        city_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(city.attributes.city_image),
                        city_services: getCategoryService(city.attributes.category_services),
                        city_services_promo: getServices(city.attributes.services)
                      };
              }), model.data);
}

function getDownloadAppMobile(data) {
  return {
          title: data.title,
          sub_text: data.sub_text,
          button_label: data.button_label,
          button_href: data.button_href,
          app_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.app_icon),
          app_store_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.app_store_image),
          google_play_store_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.google_play_store_image)
        };
}

function getImageDesc(model) {
  return {
          image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.image),
          description: model.description
        };
}

function getTextSubText(model) {
  return {
          text: model.text,
          sub_text: model.sub_text
        };
}

function getImageTitleDesc(model) {
  return {
          title: model.title,
          desc: model.desc,
          icon: MediaEntityMapper$PorterinFeature.getImage(model.icon)
        };
}

function getImageTitleDescContainer(model) {
  return {
          title: model.title,
          cards: Js_array.map(getImageTitleDesc, model.cards)
        };
}

function getLink(model) {
  return {
          href: model.href,
          label: model.label,
          target: model.target,
          is_external: model.isExternal
        };
}

function getHeroSection(data) {
  return {
          title: data.title,
          sub_text: data.sub_text,
          know_more_cta: getKnowMoreCta(data.know_more_cta),
          banner_img: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.banner_img),
          banner_img_mobile: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.banner_img_mobile)
        };
}

function getDownloadAppDesktop(data) {
  return {
          title: data.title,
          sub_title: data.sub_title,
          qr_text: data.qr_text,
          qr: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.qr)
        };
}

function getInternalLink(data) {
  return $$Array.map((function (link) {
                return {
                        title: link.title,
                        sub_text: Belt_Option.getWithDefault(link.sub_text, ""),
                        link: link.link
                      };
              }), data);
}

function getFormField(data) {
  return {
          label: data.label,
          place_holder: data.place_holder,
          error_msg: data.error_msg,
          required: data.required,
          icon: MediaEntityMapper$PorterinFeature.getOptionalImage(data.icon)
        };
}

function getInternalLinksSection(model) {
  return {
          text: model.text,
          link_section: $$Array.map((function (link) {
                  return {
                          text: link.text,
                          links: getInternalLink(link.links)
                        };
                }), model.internal_links)
        };
}

function getPointerSection(model) {
  return {
          text: model.title,
          pointer: $$Array.map((function (point) {
                  return {
                          text: point.text,
                          sub_text: point.sub_text,
                          icon: {
                            path: point.image.url,
                            alt_text: point.alt_tag
                          }
                        };
                }), model.pointer)
        };
}

function getTitleSubtext(model) {
  return {
          text: model.title,
          sub_text: model.sub_text
        };
}

function getShortLink(model) {
  return {
          href: Belt_Option.getWithDefault(model.link, ""),
          text: model.label
        };
}

export {
  getMeta ,
  getKnowMoreCta ,
  getVehicleServicesInfo ,
  getVehicleCities ,
  getTestimonial ,
  getCustomerTestimonials ,
  getFaqs ,
  getFaqsSection ,
  getTextSubtext ,
  getTestimonials ,
  getCategoryService ,
  getServices ,
  getHomeCities ,
  getDownloadAppMobile ,
  getImageDesc ,
  getTextSubText ,
  getImageTitleDesc ,
  getImageTitleDescContainer ,
  getLink ,
  getHeroSection ,
  getDownloadAppDesktop ,
  getInternalLink ,
  getFormField ,
  getInternalLinksSection ,
  getPointerSection ,
  getTitleSubtext ,
  getShortLink ,
}
/* No side effect */
